import { getVeloDependenciesConfigPath } from '@wix/cli-site-old-definitions';
import { pathExists } from '@wix/cli-fs';
import { unlink } from 'node:fs/promises';
import { addDependenciesToPackageJson } from '../files/package-json.js';
import { loadDependenciesConfig } from '../files/velo.dependencies.js';
import type { Logger } from '../logger.js';

export const migrateToAnyNpmIfNeeded = async (root: string, logger: Logger) => {
  const oldDependenciesFilePath = getVeloDependenciesConfigPath(root);
  if (await pathExists(oldDependenciesFilePath)) {
    try {
      logger.logMigratingToAnyNpm();

      const oldVeloDeps = await loadDependenciesConfig(root);
      await addDependenciesToPackageJson(root, oldVeloDeps);
      await unlink(oldDependenciesFilePath);

      logger.logMigrationToAnyNpmCompletedSuccessfully();
    } catch (ex: unknown) {
      logger.logMigrationToAnyNpmFailed();
      throw ex;
    }
  }
};
